import React, { useState } from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';
import Button from '../components/Button';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted: ", formData);
    alert("Thank you for reaching out! We will get back to you soon.");
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  return (
    <div className="pt-32 pb-20 min-h-screen bg-navy/5">
      <div className="container-custom">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-1.5 rounded-full bg-primary/10 border border-primary/20">
            <span className="text-primary font-semibold text-sm tracking-wide uppercase">Get In Touch</span>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-navy mb-6">
            Contact <span className="text-primary">Us</span>
          </h1>
          <p className="text-lg md:text-xl text-navy/70 max-w-3xl mx-auto leading-relaxed">
            Reach out to us at our global offices. We're here to help you scale securely and achieve your business goals.
          </p>
        </div>

        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {/* Chennai Location */}
          <div className="bg-white rounded-2xl shadow-xl shadow-navy/5 p-8 border border-navy/5">
            <h2 className="text-2xl font-bold text-navy mb-6">Chennai, India (Head Office)</h2>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <MapPin className="text-primary shrink-0 mt-1" />
                <p className="text-navy/70 whitespace-pre-line font-medium leading-relaxed">
                  No. 672, 3rd Floor, Temple Tower{"\n"}
                  Anna Salai, Nandanam{"\n"}
                  Chennai – 600035, India.
                </p>
              </div>
              <div className="flex items-center gap-4">
                <Phone className="text-primary shrink-0" />
                <a href="tel:+914422299222" className="text-navy/70 hover:text-primary transition-colors font-medium">+91 4422299222</a>
              </div>
              <div className="flex items-center gap-4">
                <Mail className="text-primary shrink-0" />
                <a href="mailto:support@keelis.com" className="text-navy/70 hover:text-primary transition-colors font-medium">support@keelis.com</a>
              </div>
            </div>
          </div>

          {/* Riyadh Location */}
          <div className="bg-white rounded-2xl shadow-xl shadow-navy/5 p-8 border border-navy/5">
            <h2 className="text-2xl font-bold text-navy mb-6">Riyadh, Saudi Arabia</h2>
            <div className="space-y-6">
              <div className="flex items-center gap-4">
                <Phone className="text-primary shrink-0" />
                <a href="tel:+966534688971" className="text-navy/70 hover:text-primary transition-colors font-medium">+966-534688971</a>
              </div>
              <div className="flex items-center gap-4">
                <Mail className="text-primary shrink-0" />
                <a href="mailto:RiyadhKSA@keelis.com" className="text-navy/70 hover:text-primary transition-colors font-medium">RiyadhKSA@keelis.com</a>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Form - Commented out as requested
        <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-xl shadow-navy/5 p-8 md:p-12 border border-navy/5">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-2">
                <label htmlFor="name" className="text-sm font-semibold text-navy">Full Name</label>
                <input 
                  type="text" 
                  id="name" 
                  name="name" 
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 rounded-lg border border-navy/20 focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all placeholder:text-navy/30"
                  placeholder="John Doe"
                />
              </div>
              <div className="space-y-2">
                <label htmlFor="email" className="text-sm font-semibold text-navy">Email Address</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 rounded-lg border border-navy/20 focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all placeholder:text-navy/30"
                  placeholder="john@example.com"
                />
              </div>
            </div>
            
            <div className="space-y-2">
              <label htmlFor="phone" className="text-sm font-semibold text-navy">Phone Number (Optional)</label>
              <input 
                type="tel" 
                id="phone" 
                name="phone" 
                value={formData.phone}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-lg border border-navy/20 focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all placeholder:text-navy/30"
                placeholder="+1 (555) 000-0000"
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="message" className="text-sm font-semibold text-navy">Message</label>
              <textarea 
                id="message" 
                name="message" 
                value={formData.message}
                onChange={handleChange}
                required
                rows={5}
                className="w-full px-4 py-3 rounded-lg border border-navy/20 focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all placeholder:text-navy/30 resize-y"
                placeholder="How can we help you?"
              />
            </div>

            <Button variant="primary" className="w-full py-4 text-lg">
              Send Message
            </Button>
          </form>
        </div>
        */}
      </div>
    </div>
  );
};

export default Contact;
